/**
 * Compares two numbers to see if they are close in value (e.g. compare two floats)
 * Uses the precision param to specify to how close the values must be to return true.
 * @param valueOne
 * @param valueTwo
 * @param precision optional, default is 5, which equates to 10^-5 precision
 */
export const isCloseTo = (
  valueOne: number,
  valueTwo: number,
  precision = 5
) => {
  const diff = Math.abs(valueOne - valueTwo);
  const tolerance = Math.pow(10, -precision) / 2;

  return diff < tolerance;
};
